const messages = {
  free_consultation: "Тегін консультация алу",
  homeworks_list: "Список домашних задач по уроку",
};

export default messages;
